import React from 'react';
import { Target, Award, Users, Heart, TrendingUp } from 'lucide-react';
import { aboutContent } from '../mockData';

const About = () => {
  const valueIcons = [Award, Users, Heart, TrendingUp, Target];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-orange-500 to-orange-600 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">{aboutContent.title}</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">{aboutContent.description}</p>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gray-50 rounded-2xl p-8 shadow-lg">
              <div className="flex items-center mb-6">
                <div className="bg-orange-500 p-4 rounded-full mr-4">
                  <Target className="text-white" size={32} />
                </div>
                <h2 className="text-3xl font-bold text-gray-800">Nossa Missão</h2>
              </div>
              <p className="text-lg text-gray-700 leading-relaxed">{aboutContent.mission}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
            Nossos Valores
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {aboutContent.values.map((value, index) => {
              const Icon = valueIcons[index];
              return (
                <div
                  key={index}
                  className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2"
                >
                  <div className="bg-orange-500 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                    <Icon className="text-white" size={32} />
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">{value}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Network Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">Tecnologia de Ponta</h2>
              <p className="text-lg mb-6">
                Utilizamos as mais modernas tecnologias em fibra óptica para garantir a melhor
                experiência de internet para nossos clientes.
              </p>
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">✓</span>
                  <span>Rede 100% em fibra óptica</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">✓</span>
                  <span>Equipamentos de última geração</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">✓</span>
                  <span>Monitoramento 24/7</span>
                </li>
                <li className="flex items-start">
                  <span className="text-orange-500 mr-3 text-2xl">✓</span>
                  <span>Suporte técnico especializado</span>
                </li>
              </ul>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Tecnologia fibra óptica"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
